import LazyImage from "components/elements/LazyImage";
import Typography from "components/elements/Typography";
import UserPublicResponseResource from "common/resources/User/UserPublicResponseResource";
import classNames from "classnames";
import classes from "./classes.module.scss";
import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import SubscriptionPlanService from "services/SubsciptionPlanService";
import ProjectResponseResource from "common/resources/Project/ProjectResponseResource";
import DefaultAvatar from "assets/images/default-avatar.svg";
import PosterService from "services/projects/PosterService";

const subscriptionPlanService = container.resolve(SubscriptionPlanService);
const posterService = container.resolve(PosterService);

type IProps = {
	user: Pick<UserPublicResponseResource, "id">;
	project: ProjectResponseResource;
	className?: string;
};

export default function FilmCrewBadge(props: IProps) {
	const { hasSubscriptionPlan } = useSubscriptionPlan(props.user);
	const { posterUrl } = useFilmImage(props.project);

	return (
		<div className={classNames(classes["root"], props.className)}>
			<LazyImage src={posterUrl ?? DefaultAvatar} alt="Avatar" className={classes["avatar"]} />
			{hasSubscriptionPlan && (
				<Typography type="p" size="xsmall" color="white" weight="bold" className={classes["pro-badge"]}>
					PRO
				</Typography>
			)}
		</div>
	);
}

const useFilmImage = (project: ProjectResponseResource) => {
	const [posterUrl, setPosterUrl] = useState<string | null>(null);

	const fetchPosterUrl = useCallback(async () => {
		if (!project?.poster?.file?.id) return;
		posterService.getPosterImage(project.id).then((blob) => {
			if (!blob) {
				setPosterUrl(DefaultAvatar);
				return;
			}
			setPosterUrl(URL.createObjectURL(blob));
		});
	}, [project]);

	useEffect(() => {
		fetchPosterUrl();
	}, [fetchPosterUrl]);

	return { posterUrl };
};

const useSubscriptionPlan = (user: Pick<UserPublicResponseResource, "id">) => {
	const [hasSubscriptionPlan, setHasSubscriptionPlan] = useState(false);

	useEffect(() => {
		subscriptionPlanService.getSubscriptionPlan(user.id).then((subscriptionPlan) => {
			setHasSubscriptionPlan(subscriptionPlan !== null);
		});
	}, [user]);

	return { hasSubscriptionPlan };
};
